export default "__VITE_ASSET__BYEyC9q4__"